import { InfoField } from '@occc-app/design-system';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { formatYesNoValues } from '../../formatters';

export const BreakageRefundConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const cst = getConstraintsByType('ConstraintRequiresTransactionVoucher', constraints);
  const values = cst.map((v) => v.breakageRefund);

  return <InfoField label='Refund eligible' value={formatYesNoValues(values)} />;
};
